import * as all from '../../../util/all';

const fetchMenuData = async (tourId: number): Promise<any> => {
  try {
    const { menus, menuSettings, productTypes } = await all.fetchData('public/getMenu', 'POST', { id: tourId });
    return { menus, menuSettings, productTypes };
  } catch (err) {
    console.error(err.message);
    return [];
  }
};

export { fetchMenuData };
